export interface Variable {
  key: string
  label: string
  category: VariableCategory
  description?: string
}

export type VariableCategory = 'person' | 'company' | 'author'

export const VARIABLE_CATEGORIES: Record<VariableCategory, { label: string; icon: string }> = {
  person: { label: 'Pessoa', icon: 'User' },
  company: { label: 'Empresa', icon: 'Building2' },
  author: { label: 'App/Autor', icon: 'Sparkles' },
}

export const VARIABLES: Variable[] = [
  // Person attributes
  { key: 'person.name', label: 'Nome', category: 'person' },
  { key: 'person.first_name', label: 'Primeiro nome', category: 'person' },
  { key: 'person.email', label: 'E-mail', category: 'person' },
  { key: 'person.phone', label: 'Telefone', category: 'person' },
  { key: 'person.city', label: 'Cidade', category: 'person' },
  { key: 'person.country', label: 'País', category: 'person' },
  { key: 'person.locale', label: 'Idioma', category: 'person' },
  { key: 'person.first_seen_at', label: 'Primeira visita', category: 'person' },
  { key: 'person.last_seen_at', label: 'Última visita', category: 'person' },
  { key: 'person.web_sessions_count', label: 'Sessões', category: 'person' },

  // Company attributes
  { key: 'company.name', label: 'Nome da empresa', category: 'company' },
  { key: 'company.domain', label: 'Domínio', category: 'company' },
  { key: 'company.users_count', label: 'Usuários', category: 'company' },

  // Author/App attributes
  { key: 'author.name', label: 'Nome do autor', category: 'author' },
  { key: 'author.email', label: 'E-mail do autor', category: 'author' },
  { key: 'app.name', label: 'Nome do app', category: 'author' },
]

export function getVariableByKey(key: string): Variable | undefined {
  return VARIABLES.find((v) => v.key === key)
}

export function getVariablesByCategory(category: VariableCategory): Variable[] {
  return VARIABLES.filter((v) => v.category === category)
}
